import moment from "moment";
import { v4 as uuidv4 } from 'uuid';

import template from "./pProcessRun.html";
import { Notes as NotesComponent } from '../Notes/Notes';
import { isEqual } from "lodash";
import angular from "angular";

export function pProcessRunDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pProcessRunController,
    controllerAs: 'pProcessRun',
    bindToController: true
  };

  return directive;
}

class pProcessRunController {
  constructor($scope, $location, $routeParams, $q, Auth, Work, $interval, Notes, $translate, bModal, StopWatch, OvertimeApplications, $window, $timeout, ConnectionQuality) {
    'ngInject';

    window.pProcessRun = this;

    this.NotesComponent = NotesComponent;

    this.bModal = bModal;
    this.$location = $location;
    this.Auth = Auth;
    this.$scope = $scope;
    this.Notes = Notes;
    this.StopWatch = StopWatch;
    this.Work = Work;
    this.ConnectionQuality = ConnectionQuality;
    this.$routeParams = $routeParams;
    this.$window = $window;
    this.$interval = $interval;
    this.$q = $q;
    this.$timeout = $timeout;
    this.$translate = $translate;

    this.clientToChange = null;
    this.processGroupTochange = null;

    this.projects = [];
    this.hasProjects = false;
    this.selectedProjectId = "";
    this.projectsMapper = [];

    this.hasProjectsFlag = false;
    this.internalProjects = [];
    this.selectedInternalProjectId = "";
    this.processesWithNotes = null;

    this.state = "loading";

    this.volume = 0;

    this.hidingProcess = null;
    this.unhidingProcess = null;
    this.hiddenProcessesAreVisible = false;
    this.hiddenProcessesForClientsByUser = [];
    this.hiddenProcessesGloballyByUser = [];
    this.processMappers = [];
    this.problemsUnavailable = false;
    this.OvertimeApplications = OvertimeApplications;
    this.billingTypes = [];
    this.currentTimeNotAvailableForNow = true;

    this.multiSelectSettings = {
      displayProp: 'name',
      showCheckAll: false,
      showUncheckAll: false,
      smartButtonMaxItems: 4,
      checkBoxes: true,
      scrollableHeight: 'auto',
      scrollable: true,
      enableSearch: true,
      searchField: 'name'
    };

    this.selectedKeywords = [];

    this.notesProps = {
      text: '',
      readOnly: true
    };
    this.notesAreEditable = false;

    $scope.$on("$destroy", () => { clearInterval(this.heartBeatInterval); });
    $scope.$watch(() => this.valueAdded, (curr, prev) => {
      if (prev !== curr && !curr && this.currentInterruption && prev !== undefined)
        this.billingTypeId = null;

      if (curr && this.currentInterruption)
        this.billingTypeId = this.selectedClient ? this.selectedClient.defaultBillingTypeId : this.client.defaultBillingTypeId;
    });

    this.$scope.$watch(() => this.client, () => {
      if (this.user && this.client && this.client.name)
        this.selectedClientNameToDisplay = (this.client.additionalInfo ? "(" + this.client.additionalInfo + ") " : "") + this.client.name;
      else
        this.selectedClientNameToDisplay = '';
    });

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });

    this.Auth.authorize().then(
      (user) => {
        this.user = user;

        this.getNotesInfoForClientsAndProcesses();

        if (!this.user.preferences || !this.user.preferences.featureFlags) {
          this.Auth.setFeatureFlagsToLocaleStorage(this.user).then(newUserInfo => {
            this.user = newUserInfo;
            this.timerFeatureFlag = !!this.user.preferences.featureFlags.find(f => f == "Timer");
            this.invoiceDetailsFeatureFlag = !!this.user.preferences.featureFlags.find(f => f == "InvoiceDetails");
            this.outputTypeFeatureFlag = this.user.preferences.featureFlags.some(ff => ff === "OutputType");
            this.hasProjectsFlag = this.user.preferences.featureFlags.some(f => f == "ProjectsSetManually" || f == "ProjectsFromErpSystem");
            this.overtimeApplicationsFlag = this.user.preferences.featureFlags.some(f => f == "OvertimeApplications");
            this.interactiveNotesFeatureFlag = this.user.preferences.featureFlags.some(ff => ff === "InteractiveNotes");
            this.D365IntegrationFeatureFlag = this.user.preferences.featureFlags.some(f => f == "D365Integration");
          });
        } else {
          this.timerFeatureFlag = !!this.user.preferences.featureFlags.find(f => f == "Timer");
          this.outputTypeFeatureFlag = this.user.preferences.featureFlags.some(ff => ff === "OutputType");
          this.invoiceDetailsFeatureFlag = !!this.user.preferences.featureFlags.find(f => f == "InvoiceDetails");
          this.hasProjectsFlag = this.user.preferences.featureFlags.some(f => f == "ProjectsSetManually" || f == "ProjectsFromErpSystem");
          this.overtimeApplicationsFlag = this.user.preferences.featureFlags.some(f => f == "OvertimeApplications");
          this.interactiveNotesFeatureFlag = this.user.preferences.featureFlags.some(ff => ff === "InteractiveNotes");
          this.D365IntegrationFeatureFlag = this.user.preferences.featureFlags.some(f => f == "D365Integration");
        }

        this.$q.all([this.Work.getJobCodeMappers(), this.Work.getProjectsJobCodeMappers()])
          .then(
            ([jobCodeMappersSuccess, projectsJobCodeMappers]) => {
              this.processMappers = jobCodeMappersSuccess.data.processMappers;
              this.projectsMapper = projectsJobCodeMappers.data.clientsProjectsWorklogsMappers[$routeParams.clientId];
            }
          )
          .catch(err => {
            this.error = err;
          });

        this.Work.reportStateChange("process-workspace-loading", this.user);
        Work.getWorkspace().then((workspaceData) => {
          Work.getCountryBillingTypes()
            .then(({ data: { billingTypes }}) =>
              this.billingTypes = Object.entries(billingTypes).reduce((accu, curr) => {
                accu.push({id: curr[0], name: curr[1]});
                return accu;
              }, [])
            );
            
          this.outputChoices = workspaceData.data.outputChoices;
          this.Work.reportStateChange("process-workspace-preparing", this.user);
          var workspace = workspaceData.data;
          var processGroupId = $routeParams.processGroupId;
          this.workspace = workspace;

          var timeout = $interval(() => {
            this.notes = Notes.getNotes();
            this.showOverdueProcessAlertOnNewDateAndAbort();
          }, 150);

          $scope.$on("$destroy", () => { $interval.cancel(timeout); });

          this.clients = workspace.clients.map(client => {
            const nameWithAdditionalInfo = client.additionalInfo ? "(" + client.additionalInfo + ") " + client.name : null;
            return {...client, nameWithAdditionalInfo};
          });
          this.defaultProcessGroups = workspace.processGroups;
          this.interrupts = workspace.interrupts;
          this.serviceLines = workspace.serviceLines;
          this.problems = workspace.problems.filter(x => x.processGroupId == processGroupId);
          this.problemsUnavailable = !this.problems || this.problems.length === 0;
          this.hiddenProcessesForClientsByUser = workspace.hiddenProcessesForClientsByUser;
          this.hiddenProcessesGloballyByUser = workspace.hiddenProcessesGloballyByUser;

          this.client = this.clients.filter(({ id }) => id == $routeParams.clientId)[0];
          if (!this.client) {
            this.Work.fireAndForgetMetric({ type: "ERROR_WORKSPACE_LOADING", email: this.user.emailAddress });
            this.state = "error";
            this.Notes.postNote({ type: "error", description: "ERROR_LOADING_DATA"});
            return;
          }

          var clientInProcessTimeout = $interval(() => {
            Work.getWorkspace().then((workspaceData) => {
              const clients = workspaceData.data.clients.map(client => {
                const nameWithAdditionalInfo = client.additionalInfo ? "(" + client.additionalInfo + ") " + client.name : null;
                return {...client, nameWithAdditionalInfo};
              });

              this.client = clients.filter(({ id }) => id == $routeParams.clientId)[0];
            });
          }, 60 * 60 * 1000);

          $scope.$on("$destroy", () => { $interval.cancel(clientInProcessTimeout); });

          this.multiselectKeywords = this.client.multiselectKeywords && this.client.multiselectKeywords.map(keyword => ({id: keyword, name: keyword}));
          this.billingTypeId = this.client.defaultBillingTypeId;
          var processesLookup = {};
          workspace.processes.map(x => processesLookup[x.id] = x).filter(process => !process.isHidden).filter(process => !process.isVacation);

          if (this.interactiveNotesFeatureFlag)
            this.Work.getNoteLatestVersion({clientId: this.client.id})
              .then((success) => this.clientNote = success.data.content);

          //internal interrupt ids
          this.selectedInternalProject = this.clients.filter((x) => x.name === "Internal")[0];
          this.internalProjects = this.selectedInternalProject ? this.selectedInternalProject.projects : [];
          this.hasProjectsFlag = this.internalProjects.length > 0 && this.hasProjectsFlag;

          this.processGroup = angular.copy(workspace.processGroups.filter(({ id }) => id == processGroupId)[0]);
          this.processGroup.processes = workspace.processClientConfigurations
            .filter(({ processId }) => processesLookup[processId] != undefined)
            .filter(({ clientId, processId }) => clientId == this.client.id && processesLookup[processId].processGroupId == processGroupId)
            .map((pcc) => angular.extend(angular.copy(processesLookup[pcc.processId]), angular.copy(pcc), { processClientConfigurationId: pcc.id }))
            .filter((process) => !process.isHidden)
            .filter((process) => !process.isVacation)
            .map((process) => angular.extend(process, { bookmarked: this.Work.isBookmarked(process.id) }))
            .sort((a, b) => a.name.localeCompare(b.name));
          var uniqueProcessGroupIds = {};
          workspace.processClientConfigurations
            .filter(({ processId }) => processesLookup[processId] != undefined)
            .filter(({ clientId }) => clientId == this.client.id)
            .map((pcc) => uniqueProcessGroupIds[processesLookup[pcc.processId].processGroupId] = true);

          this.onlySingleProcessGroup = Object.keys(uniqueProcessGroupIds).length == 1;

          this.hideBookmarked = !this.processGroup.processes.some((process) => process.bookmarked && this.isProcessNotHidden(process));

          // restarting if closed tab
          var resumed = this.resumeIfPossible(workspace);
          if (!resumed) {
            this.setupNewResumePoint().then(() => {
              this.state = "loaded";
              this.Work.reportStateChange("process-workspace-prepared", this.user);
            });
          } else {
            this.state = "loaded";
            this.Work.reportStateChange("process-workspace-prepared", this.user);
          }
          if (!workspace.clients || !(workspace.clients.length > 0)) {
            this.Work.fireAndForgetMetric({ type: "ERROR_WORKSPACE_EMPTY", email: this.user.emailAddress });
          }

          if (this.overtimeApplicationsFlag)
            this.OvertimeApplications.getPossibleApplicationsForEmployee(this.user.id, this.client.id, moment().format("YYYY-MM-DD")).then(
              success => this.applications = success.data,
              (error) => {
                this.Notes.postNote({ type: "error", description: "ERROR_LOADING_DATA", error: error });
                this.error = error;
              }
            );
        }, (error) => {
          this.Work.fireAndForgetMetric({ type: "ERROR_WORKSPACE_LOADING", email: this.user.emailAddress });
          this.state = "error";
          this.Notes.postNote({ type: "error", description: "ERROR_LOADING_DATA", error: error });
          this.error = error;
        });
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  getNotesInfoForClientsAndProcesses(updateCache) {
    this.Work.getNotesInfoForClientsAndProcesses(updateCache).then(
      ({ data }) =>
        this.processesWithNotes = new Set(
          data.processClients
          .filter(processClient => processClient.clientId === this.$routeParams.clientId)
          .map(processClient => processClient.processId)
        )
      , (err) => this.error = err
    );
  }

  getOutputs() {
    if (this.outputChoices) {
      if (this.outputChoices[this.finishingProcess.id]) {
        let outputs = this.outputChoices[this.finishingProcess.id].map(element => element.outputType);
        this.selectedOutput = outputs[0];

        return outputs;
      }
    }

    return this.finishingProcess.outputs;
  }

  getOutputsProblems() {
    if (this.outputChoices) {
      if (this.outputChoices[this.finishingProcessWithProblem.id]) {
        let outputs = this.outputChoices[this.finishingProcessWithProblem.id].map(element => element.outputType);
        this.selectedOutput = outputs[0];
        return outputs;
      }
    }
    return this.finishingProcessWithProblem.outputs;
  }

  slugify(string) {
    return "s-" + string.toString().toLowerCase()
      .replace(/\s+/g, '-')           // Replace spaces with -
      .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
      .replace(/\-\-+/g, '-')         // Replace multiple - with single -
      .replace(/^-+/, '')             // Trim - from start of text
      .replace(/-+$/, '');            // Trim - from end of text
  }

  setupNewResumePoint() {
    this.Work.removeAnyTraceOfTheSavedProcess();
    return this.Work.getTimeNow().then((momentTimeNow) => {
      this.startTime = momentTimeNow.toDate().getTime();
      this.Notes.postNote({ type: "start", description: this.processGroup.name, time: moment(this.startTime).format("HH:mm") });
      localStorage.setItem("roedl-time-started", angular.toJson(this.startTime));
      localStorage.setItem("roedl-time-started-pg", this.processGroup.id);
      localStorage.setItem("roedl-time-started-client-id", this.client.id);
      localStorage.setItem("roedl-time-duration-interruption", 0);
      localStorage.setItem("roedl-worklog-id", uuidv4());

      this.counter = this.StopWatch.counters.normal;
      this.counter.start = moment();
      this.StopWatch.startCounter(this.counter);
    });
  }

  resumeIfPossible(workspace) {
    var resumed = false;

    if (localStorage.getItem("roedl-time-started") &&
      localStorage.getItem("roedl-time-started-pg") == this.processGroup.id) {

      this.startTime = angular.fromJson(localStorage.getItem("roedl-time-started"));
      const allInterruptsDuration = angular.fromJson(localStorage.getItem("roedl-time-duration-interruption"));

      this.counter = this.StopWatch.counters.normal; // 0:0:0
      this.counter.start = moment(this.startTime);
      this.counter.startWithInterrupt = this.counter.start.clone().add(allInterruptsDuration, 'ms');

      if (localStorage.getItem("roedl-time-started-interruption")) {
        var interruption = angular.fromJson(localStorage.getItem("roedl-time-started-interruption"));

        if (!localStorage.getItem("roedl-interruption-id"))
          localStorage.setItem("roedl-interruption-id", uuidv4());

        this.currentInterruption = workspace.interrupts.filter(({ id }) => id == interruption.interruption.id)[0];
        this.interruptionStartTime = interruption.time;
        this.checkFinishTimeAvailableForInterrupt();
        this.fixInterruption();
        this.Notes.postNote({ type: "resume", description: this.currentInterruption.name, time: moment(this.interruptionStartTime).format("HH:mm") });

        let procDurWithoutInter = moment.duration((this.interruptionStartTime - this.startTime) - allInterruptsDuration); // process duration: from start to startInterrupt except all previous interruptions

        this.StopWatch.setNewCounterTime(this.counter, procDurWithoutInter); // restore this.counter time (it is only for display static time on counter normal)

        this.counterInt = this.StopWatch.counters.interrupt;
        this.counterInt.start = moment(interruption.time);
        this.StopWatch.stopCounter(this.counterInt); // clearInterval
        this.StopWatch.startCounter(this.counterInt);
      } else {
        this.Notes.postNote({ type: "resume", description: this.processGroup.name, time: moment(this.startTime).format("HH:mm") });

        this.StopWatch.stopCounter(this.counter); //clearInterval
        this.StopWatch.startCounter(this.counter);
      }
      resumed = true;
    }
    return resumed;
  }

  cancelRoute() {
    if (this.onlySingleProcessGroup) {
      return `/clients/`;
    } else {
      return `/clients/${this.client.id}/${this.slugify(this.client.name)}/`;
    }
  }

  cancel() {
    this.Work.reportStateChange("process-canceling", this.user);
    if (this.Work.processIsLongEnoughToAskIfWeWantToContinue()) {
      this.modalConfig = {
        text: "WORK.CANCEL_CONFIRMATION",
        cancelText: "WORK.EXIT",
        acceptText: "WORK.RESUME_PROCESS"
      };
      this.bModal.show(this.modalConfig).then(
        () => {
          angular.noop;
        },
        () => {
          this.Work.removeAnyTraceOfTheSavedProcess();
          this.$location.path(this.cancelRoute());
          this.StopWatch.stopAndclearCounter(this.counter);
        }
      );
    } else {
      this.Work.removeAnyTraceOfTheSavedProcess();
      this.$location.path(this.cancelRoute());
      this.StopWatch.stopAndclearCounter(this.counter);
    }
  }

  bookmarkProcess(process) {
    process.bookmarked = !process.bookmarked;
    this.hideBookmarked = !this.processGroup.processes.some((process) => process.bookmarked && this.isProcessNotHidden(process));
    if (!this.Work.isBookmarked(process.id)) {
      this.Work.bookmark(process.id, "ProcessGroup");
    } else {
      this.Work.unbookmark(process.id);
    }
  }

  checkFinishTimeAvailableForInterrupt() {
    this.minChangeFinishTimeValue = this.interruptionStartTime + 1000;
    const changeFinishTimeValue = moment().subtract(1, "minute").startOf('minute');
    const changeFinishTimeValueFormatted = changeFinishTimeValue.format("HH:mm:ss");
    const currentTimeNotAvailableForNow = moment(changeFinishTimeValueFormatted, "HH:mm:ss").isSameOrBefore(moment(this.minChangeFinishTimeValue), 'seconds');

    let intervalDuration;
    if (currentTimeNotAvailableForNow) {
      intervalDuration = moment(this.minChangeFinishTimeValue).startOf('minute').add(2, 'minute').valueOf() - new Date().valueOf();
    } else {
      intervalDuration = moment().startOf('minute').add(1, 'minute').valueOf() - new Date().valueOf();
    }

    clearInterval(this.checkInterruptsDuringProcessInterval);
    this.checkInterruptsDuringProcessInterval = setInterval(() => this.checkFinishTimeAvailableForInterrupt(), intervalDuration);
    this.currentTimeNotAvailableForNow = currentTimeNotAvailableForNow;
  }

  handleInterruption(interruption) {
    this.state = "loading";
    this.billingTypeId = null;
    this.selectedKeywords = null; 
    this.multiselectKeywords = null;
    this.Work.getTimeNow().then((momentTimeNow) => {
      this.state = "loaded";
      this.interruptionStartTime = momentTimeNow.toDate().getTime();
      this.checkFinishTimeAvailableForInterrupt();
      this.currentInterruption = interruption;
      this.fixInterruption();
      localStorage.setItem("roedl-time-started-interruption", angular.toJson({ time: this.interruptionStartTime, interruption: this.currentInterruption }));
      localStorage.setItem("roedl-interruption-id", uuidv4());

      this.StopWatch.stopCounter(this.counter);
      this.counterInt = this.StopWatch.counters.interrupt;
      this.counterInt.start = moment();
      this.StopWatch.startCounter(this.counterInt);
      if (this.D365IntegrationFeatureFlag)
        this.projects = this.clients.find(client => client.name === 'Internal').projects;
    });
  }

  fixInterruption() {
    if (this.currentInterruption.hasClient && this.currentInterruption.hasServiceLine) {
      this.currentInterruption.choice = undefined;
    } else if (this.currentInterruption.hasClient) {
      this.currentInterruption.choice = "client";
    } else if (this.currentInterruption.hasServiceLine) {
      this.currentInterruption.choice = "serviceLine";
    } else {
      this.currentInterruption.choice = "none";
    }
  }

  cancelInterruption() {
    localStorage.removeItem("roedl-time-started-interruption");
    localStorage.removeItem("roedl-interruption-id");
    this.clientSearch = "";
    this.selectedClient = undefined;
    this.selectedServiceLine = undefined;
    this.currentInterruption = undefined;
    this.comment = "";
    this.selectedOutput = "";
    this.invoiceDetails = null;
    this.valueAdded = false;
    this.selectedProjectId = this.projects[0] && this.client.projects[0] && this.client.projects[0].id;
    this.selectedKeywords = [];
    this.billingTypeId = this.client.defaultBillingTypeId;
    this.changeFinishTimeDefaultValue = this.changeFinishTimeValue = this.changeFinishTime = this.minChangeFinishTimeValue = null;
    this.changeFinishTimeValueFormatError = false;
    this.changeFinishTimeValueMinError = false;
    this.changeFinishTimeValueMaxError = false;
    if (this.changeInvoicingTime) {
      this.changeInvoicingTime = false;
      this.changeInvoicingTimeValue = null;
      this.changeInvoicingTimeValueError = null;
    }

    this.StopWatch.stopAndclearCounter(this.counterInt);
    this.StopWatch.startCounter(this.counter);
  }

  cancelFinishingProcess() {
    this.selectedProblem = undefined;
    this.selectedClient = undefined;
    this.currentInterruption = undefined;
    this.finishingProcessWithProblem = undefined;
    this.finishingProcess = undefined;
    this.changeFinishTimeDefaultValue = this.changeFinishTimeValue = this.changeFinishTime = this.minChangeFinishTimeValue = null;
    this.currentTimeNotAvailableForNow = true;
    this.comment = "";
    this.selectedOutput = "";
    this.invoiceDetails = null;
    this.selectedProjectId = this.projects[0] && this.client.projects[0] && this.client.projects[0].id;
    this.volume = 0;
    this.selectedKeywords = [];
    this.changeFinishTimeValueFormatError = false;
    this.changeFinishTimeValueMinError = false;
    this.changeFinishTimeValueMaxError = false;
    this.valueAdded = false;
    if (this.changeInvoicingTime) {
      this.changeInvoicingTime = false;
      this.changeInvoicingTimeValue = null;
      this.changeInvoicingTimeValueError = null;
      this.StopWatch.startCounter(this.counter);
    }
    clearInterval(this.checkInterruptsDuringProcessInterval);
  }

  finishAndRestart(process) {
    this.checkInterruptsDuringProcess();
    this.projects = this.client.projects;
    this.hasProjects = this.projects.length > 0;
    if (this.hasProjects) { this.selectedProjectId = this.projects[0].id; }
    if (process.allowChangingValueAdded) this.valueAdded = process.valueAdded;
    this.endOnFinish = false;
    this.finishingProcess = process;
    this.outputs = this.getOutputs();
  }

  async checkInterruptsDuringProcess(checkInvokedByFinishProcess) {
    const minChangeFinishTimeValue = this.startTime + 1000;
    const from = moment(this.startTime).format('YYYY-MM-DDTHH:mm:ssZ');
    let data;

    if (this.currentTimeNotAvailableForNow) {
      const response = await this.Work.getInterruptsDuringProcess({from});
      data = response.data;
    }

    if (data) {
      this.minChangeFinishTimeValue =
          data.map(({finishedAt}) => new Date(finishedAt).valueOf() + 1000).sort().reverse()[0]
          || minChangeFinishTimeValue;

    } else {
      this.minChangeFinishTimeValue = this.minChangeFinishTimeValue || minChangeFinishTimeValue;
    }

    const changeFinishTimeValue = checkInvokedByFinishProcess ? moment(this.changeFinishTimeValue, "HH:mm:ss") : moment().subtract(1, "minute").startOf('minute');
    const changeFinishTimeValueFormatted = changeFinishTimeValue.format("HH:mm:ss");
    const currentTimeNotAvailableForNow = moment(changeFinishTimeValueFormatted, "HH:mm:ss").isSameOrBefore(moment(this.minChangeFinishTimeValue), 'seconds');

    if (!checkInvokedByFinishProcess) {
      let intervalDuration;
      if (currentTimeNotAvailableForNow) {
        intervalDuration = moment(this.minChangeFinishTimeValue).startOf('minute').add(2, 'minute').valueOf() - new Date().valueOf();
      } else {
        intervalDuration = moment().startOf('minute').add(1, 'minute').valueOf() - new Date().valueOf();
      }
      clearInterval(this.checkInterruptsDuringProcessInterval);
      this.checkInterruptsDuringProcessInterval = setInterval(() => this.checkInterruptsDuringProcess(), intervalDuration);
    }

    this.currentTimeNotAvailableForNow = currentTimeNotAvailableForNow;

    if (checkInvokedByFinishProcess)
      this.checkingIfChangeIsAvailable = false;

    if (this.currentTimeNotAvailableForNow) {
      this.changeFinishTime = false;
      this.changeFinishTimeValue = null;
      this.changeFinishTimeDefaultValue = null;

      if (checkInvokedByFinishProcess)
        this.Notes.postNote({
          type: "changeFinishTimeError",
          description: 'Changed finish time is overlapping with another entry.',
          disappearAfter: 15 * 1000
        });
    }

    return;
  }

  finishWithProblem(process) {
    this.checkInterruptsDuringProcess();

    this.projects = this.client.projects;
    this.hasProjects = this.projects.length > 0;
    if (this.hasProjects) { this.selectedProjectId = this.projects[0].id; }
    if (process.allowChangingValueAdded) this.valueAdded = process.valueAdded;
    this.endOnFinish = false;
    this.finishingProcessWithProblem = process;
    this.outputs = this.getOutputsProblems();
    if (this.hasOutputs('finishingProcessWithProblem'))
      this.selectedOutput = this.selectMostUsedOutput(this.outputs, process);
  }

  finishProcessAndGroup(process) {
    this.checkInterruptsDuringProcess();

    this.projects = this.client.projects;
    this.hasProjects = this.projects.length > 0;
    if (this.hasProjects) { this.selectedProjectId = this.projects[0].id; }

    this.endOnFinish = true;
    if (
      process.hasVolume
      || process.commentRequired
      || this.hasProjects
      || (this.applications && this.applications.length > 0)
      || this.client.defaultBillingTypeId
    ) {
      this.valueAdded = process.valueAdded;
      this.finishingProcess = process;
      this.outputs = this.getOutputs();
    } else {
      this.finishingProcess = process;
      this.postFinish();
      this.outputs = this.getOutputs();
    }

    if (this.hasOutputs('finishingProcess'))
      this.selectedOutput = this.selectMostUsedOutput(this.outputs, process);
  }

  reportInterruption() {
    this.postFinish();
  }

  selectInterruptClient(client) {
    this.projects = client.projects;
    if (this.projects.length > 0) { this.selectedProjectId = this.projects[0].id; }
    this.selectedClient = client;

    const multiselectKeywords = this.selectedClient.multiselectKeywords && this.selectedClient.multiselectKeywords.map(keyword => ({id: keyword, name: keyword}));
    if (!isEqual(multiselectKeywords, this.multiselectKeywords))
      this.selectedKeywords = [];
    this.multiselectKeywords = multiselectKeywords;
    if (this.selectedClient.defaultBillingTypeId)
      this.billingTypeId = this.selectedClient.defaultBillingTypeId;
    else
      this.billingTypeId = null;
  }


  clearSelections() {
    this.currentInterruption.choice = undefined;
    this.selectedClient = undefined;
    this.selectedServiceLine = undefined;
    this.billingTypeId = this.client.defaultBillingTypeId;
  }

  showOverdueProcessAlertOnNewDateAndAbort() {
    var finishProcess = false;
    var startTime = angular.fromJson(localStorage.getItem("roedl-time-started"));
    const theresASavedProcess = localStorage.getItem("roedl-time-started");
    const processIsOverdue = this.Work.processIsOverdue(moment.unix(startTime / 1000));

    if (theresASavedProcess && processIsOverdue) {
      this.modalConfig = {
        text: "WORK.PROCESS_TOO_LONG",
        cancelText: "",
        acceptText: "WORK.EXIT",
        hideLeftButton: "hide"
      };
      
      if (!this.sentOverDueMetric) {
        this.Work.reportStateChange("process-overdue-message", this.user);
      }
      this.bModal.show(this.modalConfig).then(() => {
        this.Work.removeAnyTraceOfTheSavedProcess();
        this.StopWatch.stopAndclearCounter(this.counter);
        this.Work.reportStateChange("process-overdue-canceled", this.user);
        this.$location.path(this.cancelRoute());
      }, angular.noop);

      finishProcess = true;
      this.sentOverDueMetric = true;
    } else {
      this.sentOverDueMetric = false;
    }
    return finishProcess;
  }

  showLongProjectName(selectedProjectId) {
    let longName = "";

    if (window.DD_LOGS && !this.projects) {
      window.DD_LOGS.logger.error(
        "DD HANDLER - missing projects", {project: this.projects}
      );
      window.DD_LOGS.logger.error(
        "DD HANDLER - missing projects", {state: this.state}
      );
      window.DD_LOGS.logger.error(
        "DD HANDLER - missing projects", {client: this.client}
      );
    }
    
    this.projects.forEach((x) => {
      if (x.id === selectedProjectId) {
        longName = x.name;
      }
    });
    if (longName.length > 35)
      return longName;
  }

  shouldSetOutput() {
    return (this.finishingProcessWithProblem && this.finishingProcessWithProblem.outputs && this.finishingProcessWithProblem.outputs.length > 0) || (this.finishingProcess && this.finishingProcess.outputs && this.finishingProcess.outputs.length > 0);
  }

  postFinish() {
    if (this.state == "loading")
      return;

    clearTimeout(this.checkInterruptsDuringProcessInterval);

    this.state = "loading";
    this.Work.getTimeNow().then((momentTimeNow) => {
      let endTime = momentTimeNow;
      let offset;
      if (this.changeFinishTime) {
        const [newHours, newMinutes, newSeconds] = this.changeFinishTimeValue.split(':');
        const originalDate = new Date(momentTimeNow);
        originalDate.setHours(parseInt(newHours), parseInt(newMinutes), parseInt(newSeconds), 0);
        endTime = moment.parseZone(originalDate.toISOString(), ["YYYY-MM-DDTHH:mm:ss.SSSZ", "YYYY-MM-DDTHH:mm:ssZ"]);
        offset = moment.duration(momentTimeNow - endTime);
      }
      var timeNow = endTime.toDate().getTime();
      var finishedAt = moment(timeNow).format("HH:mm");
      var correlationId = "post-" + this.user.id + "-" + timeNow;

      var process = this.finishingProcess || this.finishingProcessWithProblem;
      var interupt = this.currentInterruption;
      var worklog;

      if (process) {
        const duration = this.changeInvoicingTime
          ? moment.duration(this.formatCounterToTime(this.counter), "HH:mm:ss")
          : "PT" + ((timeNow - this.startTime) / 1000).toFixed(4) + "S";
        worklog = {
          duration: duration,
          processClientConfigurationId: process.processClientConfigurationId,
          clientId: this.client.id,
          comment: this.comment,
          invoiceDetails: this.invoiceDetails,
          zoneId: this.user.timezone || moment.tz.guess(),
          startTimeCheck: this.startTime,
          id: localStorage.getItem("roedl-worklog-id")
        };
        if (process.allowChangingValueAdded) worklog.valueAdded = this.valueAdded;
        if (this.outputTypeFeatureFlag && this.shouldSetOutput() && process.hasVolume) {
          worklog = {
            ...worklog,
            outputType: this.selectedOutput,
          };
        }
        if (this.projects.length > 0) {
          worklog.projectId = this.selectedProjectId;
        }
        if (this.selectedProblem) { worklog.problemId = this.selectedProblem; }
        if (process.hasVolume) { worklog.volume = this.volume; }
      } else if (interupt) {
        const duration = this.changeInvoicingTime
          ? moment.duration(this.formatCounterToTime(this.counterInt), "HH:mm:ss")
          : "PT" + ((timeNow - this.interruptionStartTime) / 1000).toFixed(4) + "S";
        worklog = {
          duration: duration,
          interruptId: this.currentInterruption.id,
          comment: this.comment,
          invoiceDetails: this.invoiceDetails,
          zoneId: this.user.timezone || moment.tz.guess(),
          startTimeCheck: this.interruptionStartTime,
          valueAdded: this.valueAdded,
          id: localStorage.getItem("roedl-interruption-id")
        };
        if (this.hasProjectsFlag && this.currentInterruption.choice && this.currentInterruption.choice != 'client' && this.internalProjects.length > 0) {
          worklog = {
            ...worklog,
            projectId: this.selectedInternalProjectId
          };
        }
        if (this.selectedClient && this.projects.length > 0) {
          worklog.projectId = this.selectedProjectId;
        }
        if (this.outputTypeFeatureFlag && this.finishingProcess && this.finishingProcess.outputs && this.finishingProcess.outputs.length > 0 && process.hasVolume) {
          worklog = {
            ...worklog,
            outputType: this.selectedOutput,
          };
        }
        if (this.outputTypeFeatureFlag && this.finishingProcessWithProblem && this.finishingProcessWithProblem.outputs && this.finishingProcessWithProblem.outputs.length > 0 && process.hasVolume) {
          worklog = {
            ...worklog,
            outputType: this.selectedOutput,
          };
        }
        if (this.selectedClient) { worklog.clientId = this.selectedClient.id; }
        if (this.selectedServiceLine) { worklog.serviceLine = this.selectedServiceLine; }
      }

      if (this.applicationOvertime)
        worklog.overtimeApplicationId = this.applicationOvertime;

      if (this.billingTypeId && (process || interupt && worklog.valueAdded))
        worklog.billingTypeId = this.billingTypeId;

      if (this.selectedKeywords && this.selectedKeywords.length > 0)
        worklog.clientMultiselectKeywords = this.selectedKeywords.map(keyword => keyword.name);

      if (offset)
        worklog.offset = offset;

      if (this.changeInvoicingTime)
        worklog.invoicedTime = moment.duration(this.changeInvoicingTimeValue);

      //* DISCARDING OVERNIGHT PROCESSES*//
      if (this.Work.processIsOverdue(moment.unix(worklog.startTimeCheck / 1000))) {
        this.Notes.postNote({ type: "error", description: "WORK.ERROR_PROCESS_TOO_LONG", correlationId: correlationId });
        this.Work.fireAndForgetMetric({
          type: "ERROR_PROCESS_TOO_LONG",
          email: this.user.emailAddress,
          startTime: this.startTime,
          timeNow: timeNow,
          interruptionStartTime: this.interruptionStartTime,
          finishedAt: finishedAt,
          process: process,
          interupt: interupt,
          worklog: worklog
        }, correlationId).then(angular.noop, angular.noop);
        this.state = "error";
      } else {
        this.Work.reportStateChange("process-posting", this.user, correlationId);
        this.Work.log(worklog, correlationId).then((savedProcess) => {
          this.Work.reportStateChange("process-posted", this.user, correlationId);

          if (process && !worklog.problemId) {
            this.Notes.postNote({ type: "finish", description: process.name, time: finishedAt });
            this.StopWatch.stopAndclearCounter(this.counter);
          }
          if (process && worklog.problemId) {
            this.Notes.postNote({ type: "problem", description: process.name, time: finishedAt });
            this.StopWatch.stopAndclearCounter(this.counter);
          }

          this.currentTimeNotAvailableForNow = true;
          this.changeFinishTimeDefaultValue = this.changeFinishTimeValue = this.minChangeFinishTimeValue = null;
          
          if (this.changeFinishTime && process) {
            this.StopWatch.setNewCounterTime(this.counter, offset);

            this.counter = this.StopWatch.counters.normal;
            const newStartTime = endTime.add(1, 'ms');
            this.startTime = newStartTime;
            this.counter.start = moment(newStartTime.valueOf());

            localStorage.setItem("roedl-time-started", angular.toJson(newStartTime.valueOf()));
            localStorage.setItem("roedl-time-duration-interruption", 0);
            localStorage.setItem("roedl-worklog-id", uuidv4());

            this.StopWatch.startCounter(this.counter);
            this.finishingProcess = undefined;
            this.startNewProcessModal = false;

            this.state = "loaded";

            const selectedNewClient = JSON.parse(this.selectedNewClient);
            const selectedNewProcessGroup = JSON.parse(this.selectedNewProcessGroup);
            localStorage.setItem("roedl-time-started-client-id", selectedNewClient.id);
            localStorage.setItem("roedl-time-started-pg", selectedNewProcessGroup.id);
            this.$location.path(`/clients/${selectedNewClient.id}/${this.slugify(selectedNewClient.name)}/work/${selectedNewProcessGroup.id}/${this.slugify(selectedNewProcessGroup.name)}`);

            this.selectedNewClient = null;
            this.selectedNewProcessGroup = null;
          }

          if (interupt) {
            this.Notes.postNote({ type: "interruption", description: interupt.name, time: finishedAt });

            const interruptDuration = offset ? moment.duration(worklog.duration, 'milliseconds') : timeNow - this.interruptionStartTime;
            const allInterruptsDuration = angular.fromJson(localStorage.getItem("roedl-time-duration-interruption"));
            localStorage.setItem("roedl-time-duration-interruption", interruptDuration + allInterruptsDuration);
            this.StopWatch.stopAndclearCounter(this.counterInt);
            this.counter.startWithInterrupt = this.counter.start.clone().add(interruptDuration + allInterruptsDuration, 'ms');
            this.StopWatch.startCounter(this.counter);
          }
          this.selectedProblem = undefined;
          this.selectedClient = undefined;
          this.selectedServiceLine = undefined;
          this.clientSearch = "";
          this.comment = "";
          this.invoiceDetails = null;
          this.interruptionStartTime = undefined;
          this.finishingProcess = undefined;
          this.finishingProcessWithProblem = undefined;
          this.currentInterruption = undefined;
          this.volume = 0;
          this.valueAdded = false;
          this.changeInvoicingTime = false;
          this.changeInvoicingTimeValue = null;
          this.changeInvoicingTimeValueError = null;

          if (!process) {
            localStorage.removeItem("roedl-time-started-interruption");
            localStorage.removeItem("roedl-interruption-id");
            this.state = "loaded";
          }

          this.selectedKeywords = [];
          this.multiselectKeywords = this.client.multiselectKeywords && this.client.multiselectKeywords.map(keyword => ({id: keyword, name: keyword}));
          this.billingTypeId = this.client.defaultBillingTypeId;

          if (this.changeFinishTime) {
            this.changeFinishTime = null;
            this.endOnFinish = false;
            return;
          }

          if (process) {
            if (!this.endOnFinish) {
              this.Work.reportStateChange("process-new-resume-point", this.user, correlationId);
              this.setupNewResumePoint(savedProcess).then(() => {
                this.state = "loaded";
              });
            } else {
              this.Work.reportStateChange("process-closing-on-finish", this.user, correlationId);
              this.Work.removeAnyTraceOfTheSavedProcess();
              if (this.onlySingleProcessGroup) {
                this.$location.path(`/clients/`);
              } else {
                this.$location.path(`/clients/${this.client.id}/${this.slugify(this.client.name)}/`);
              }
              this.state = "loaded";
            }
          }
        }, (error) => {
          // eslint-disable-next-line no-console
          console.error("KliX ERROR INFO:", error, '- ID:', this.user.id);
          this.Work.reportStateChange("process-posting-error", this.user, correlationId);
          this.Work.fireAndForgetMetric({
            type: "ERROR",
            email: this.user.emailAddress,
            startTime: this.startTime,
            timeNow: timeNow,
            interruptionStartTime: this.interruptionStartTime,
            finishedAt: finishedAt,
            process: process,
            interupt: interupt,
            worklog: worklog
          }, correlationId).then(angular.noop, angular.noop);

          if (error.data.details && error.data.details.length > 0)
            this.Notes.postNote({
              type: "detailedError",
              description: this.generateDetailedWorklogError(error.data),
              disappearAfter: 60 * 1000
            });
          else
            this.Notes.postNote({
              type: "error",
              description: error.status === -1
                ? "WORK.ERROR_KLIX_CONNECTION"
                : error.data.message || "WORK.ERROR_SENDING",
              error: error,
              correlationId: correlationId,
              vacation: error.data && error.data.message && error.data.message.indexOf("vacation") >= 0
            });

          this.state = "loaded";
        }).catch((error) => {
          this.Notes.postNote({
            type: "error",
            description: "WORK.ERROR_KLIX_CONNECTION",
            error: error,
            correlationId: correlationId,
            vacation: error.data && error.data.message && error.data.message.indexOf("vacation") >= 0
          });
          this.state = "error";
        });

        // REMOVE PROCESS INFORMATION IF IT DOESNT SHOW UP MODAL
        if (
          process
          && !(
            process.hasVolume
            || !this.endOnFinish
            || process.commentRequired
            || (this.applications && this.applications.length > 0)
            || this.client.defaultBillingTypeId
          )
          && !this.changeFinishTime
        ) {
          this.finishingProcess = undefined;
          this.currentTimeNotAvailableForNow = true;
          this.changeFinishTimeDefaultValue = this.changeFinishTimeValue = this.changeFinishTime = this.minChangeFinishTimeValue = null;
          this.finishingProcessWithProblem = undefined;
        }
      }
    });
  }

  generateDetailedWorklogError(error) {
    const errorDetails = error.details[0];

    function formatDate(date) {
      return `${moment(date).format("YYYY-MM-DD")} ${date.slice(11).slice(0, 8)}`;
    }

    const errorEnding = `which started ${formatDate(errorDetails.startedAt.replace(/\[.*\]/g, ''))} and finished ${formatDate(errorDetails.finishedAt.replace(/\[.*\]/g, ''))}.`;
    const errorFor = `for ${errorDetails.clientName} - ${errorDetails.processGroupCountryConfigurationName} - ${errorDetails.processName}`;

    switch (errorDetails.errorType) {
      case 'EntriesOverlapPartially':
      case 'ProcessesOverlapPartially':
        return `Entry overlap partially with ${errorDetails.processName ? 'worklog' : 'interrupt'} ${errorFor} ${errorEnding}`;
      case 'EditedInterruptWouldContain':
        return `Edited interrupt would contain other entry ${errorFor} ${errorEnding}`;
      case 'EntryIsContainedByOtherEntries':
        return `Entry is contained by other ${errorDetails.processName ? 'worklog' : 'interrupt'} ${errorFor} ${errorEnding}`;
    }
  }

  // If there is only process ID it will hide process for all the clients.
  // If there is client ID, this process will be hidden only for this client.
  hideProcess(forAll) {
    this.state = 'loading';

    const data = {
      processId: this.hidingProcess
    };

    if (!forAll) {
      data.clientId = this.client.id;
    }

    this.Work.hideProcess(data).then(
      () => {
        if (forAll) {
          this.hiddenProcessesGloballyByUser.push(this.hidingProcess);
        } else {
          this.hiddenProcessesForClientsByUser.push({clientId: this.client.id, processId: this.hidingProcess});
        }
        this.hidingProcess = null;
        this.hideBookmarked = !this.processGroup.processes.some((process) => process.bookmarked && this.isProcessNotHidden(process));
        this.state = 'loaded';
      }
      , (error) => {
        this.state = "error";
        this.Notes.postNote({ type: "error", description: "ERROR_LOADING_DATA", error: error });
        this.error = error;
      }
    );
  }

  //showUnhiddenProcesses - false when you want to show only hidden processes
  //showUnhiddenProcesses - true when you want to show only unhidden processes
  filterProcesses(showUnhiddenProcesses) {
    var self = this;
    return function(process) {
      return showUnhiddenProcesses == self.isProcessNotHidden(process);
    };
  }

  isProcessNotHidden(process) {
    return (
      !this.hiddenProcessesForClientsByUser
        .filter(p => p.clientId === this.client.id)
        .map(p => p.processId)
        .includes(process.processId) &&
      !this.hiddenProcessesGloballyByUser.includes(process.processId)
    );
  }

  unhideProcess() {
    this.state = 'loading';
    let request = [];
    if (this.hiddenProcessesGloballyByUser.includes(this.unhidingProcess)) {
      request.push(this.Work.uncoverProcessForAllClients(this.unhidingProcess));
    } else {
      request.push(this.Work.uncoverProcessForClient(this.unhidingProcess, this.client.id));
    }

    Promise.all(request).then(
      () => {
        let index;
        if (this.hiddenProcessesGloballyByUser.includes(this.unhidingProcess)) {
          index = this.hiddenProcessesGloballyByUser.findIndex(process => process === this.unhidingProcess);
          this.hiddenProcessesGloballyByUser.splice(index, 1);
        } else {
          index = this.hiddenProcessesForClientsByUser.findIndex(process => process.clientId === this.client.id && process.processId === this.unhidingProcess);
          this.hiddenProcessesForClientsByUser.splice(index, 1);
        }
        this.unhidingProcess = null;
        this.hideBookmarked = !this.processGroup.processes.some((process) => process.bookmarked && this.isProcessNotHidden(process));
        this.state = 'loaded';
      }, (error) => {
        // this.Work.fireAndForgetMetric({ type: "ERROR_WORKSPACE_LOADING", email: this.user.emailAddress });
        this.state = "error";
        this.Notes.postNote({ type: "error", error: error });
        this.error = error;
      }
    );
  }

  //returned value can be:
  // - null so nothing is showed in tooltip about jobcodes
  // - tuple [ID which is number, NAME which is string] (e.g. [1590, 'Payments']) what means every project has the same jobCode and it is main (process group) jobCode
  // - array of strings (e.g. ["Payments - 1590", "Regular Financial accounting - 7040"]) what means, at least one project has different jobCode than the process group
  jobCodeDescription(objToMap) {
    if (!this.processMappers || this.processMappers.length === 0 || objToMap.jobCodeDescription)
      return;
  
    const projects = [];
    const deduplicatedJobCodes = new Set();
    const jobCode = this.processMappers.find(process => process.processId === objToMap.processId);

    if (!this.projectsMapper) {
      objToMap.jobCodeDescription = null;
      return;
    }

    this.projectsMapper.forEach(project => {
      const processJobCodes = project.processesJobCodes[objToMap.processId];
      const id = processJobCodes && processJobCodes.id || jobCode && jobCode.jobCodeId;

      if (id) {
        deduplicatedJobCodes.add(id);
        projects.push(`${project.projectName} - ${id}`);
      }
    });

    objToMap.jobCodeDescription = jobCode && jobCode.jobCodeId && (deduplicatedJobCodes.size === 1 && deduplicatedJobCodes.has(jobCode.jobCodeId) || deduplicatedJobCodes.size === 0) ? [jobCode.jobCodeId, jobCode.jobCodeName] : Array(...new Set(projects));
  }

  checkTypeof(elem) {
    return typeof elem;
  }

  processIsException(process) {
    if (!this.processMappers)
      return false;

    const jobCode = this.processMappers.find(proc => proc.processId === process.processId);
    return jobCode && jobCode.isException;
  }

  hasOutputs(processType) {
    const process = processType === 'finishingProcessWithProblem'
      ? this.finishingProcessWithProblem
      : processType === 'finishingProcess'
      ? this.finishingProcess
      : null;

    if (!process) {
      return null;
    }

    return this.outputTypeFeatureFlag && process.outputs && process.outputs.length > 0 && process.hasVolume;
  }

  selectMostUsedOutput(outputs, process) {
    if (!this.outputChoices[process.id])
      return outputs[0];

    const sortedOutputs = Object.values(this.outputChoices[process.id])
      .filter(output => outputs.includes(output.outputType))
      .sort((outputA, outputB) => outputB.howMany - outputA.howMany);

    return sortedOutputs.length > 0 ? sortedOutputs[0].outputType : outputs[0];
  }

  getHeartbeat(processId) {
    this.Work.getHeartbeat({clientId: this.$routeParams.clientId, processId: processId}).then(
      (success) => {
        this.notesAreEditable = success.data.canUserCreateNoteHeartbeat;
      }
    );
  }

  openNotesModal(processId) {
    this.$q.all([
      this.Work.getNoteLatestVersion({clientId: this.$routeParams.clientId, processId: processId}),
      this.Work.getClientsAutomationTechnology({clientId: this.$routeParams.clientId, processId: processId}),
      this.Work.getAutomationTechnologyForCountry()
    ]).then(
      (success) => {
        this.notesModal = true;
        this.notesProps.processId = processId;
        this.notesProps.text = (success[0].data && success[0].data.content) || '';
        if (success[1].data && success[1].data.automationIds.length > 0 && success[2].data.automations)
          this.notesProps.automation = success[1].data.automationIds.map(technologyId => success[2].data.automations[technologyId]).sort();
        else
          this.notesProps.automation = [];

        const processesWithNotes = this.processesWithNotes && this.processesWithNotes.has(processId);
        if (this.notesProps.text === '' && processesWithNotes || this.notesProps.text !== '' && !processesWithNotes)
          this.getNotesInfoForClientsAndProcesses(true);
        this.getHeartbeat(processId);
        this.heartBeatInterval = setInterval(() => this.getHeartbeat(processId), 60 * 1000);
      },
      (error) => {
        this.Notes.postNote({ type: "noteError", description: "ERROR_LOADING_DATA", error: error });
        this.error = error;
      }
    );
  }

  closeNotesModal() {
    this.notesModal = null;
    this.notesProps = {
      ...this.notesProps,
      kill: true
    };

    this.$timeout(() => {
      this.notesProps = {
        text: '',
        readOnly: true
      };
      this.notesAreEditable = false;
      clearInterval(this.heartBeatInterval);
      this.heartBeatInterval = null;
    }, 500);
  }

  openProcessNotes(notesProps) {
    const processName = this.processGroup.processes.find(process => process.processId === notesProps.processId).name;
    sessionStorage.setItem('notes-info', JSON.stringify({
      client: this.client.name,
      processGroup: this.processGroup.name,
      process: processName
    }));
    this.notesAreEditable = false;

    this.$window.open(this.$location.url() + `/notes?processId=${notesProps.processId}&processName=${processName}`);
  }

  notesPageError() {
    this.Notes.postNote({ type: "noteError", description: 'Someone is just editing a note.' });
  }

  notesPageClosed() {
    this.notesAreEditable = true;
  }

  noteSaved() {
    this.getNotesInfoForClientsAndProcesses(true);
    this.closeNotesModal();
    this.Notes.postNote({ type: 'noteSaved', description: "Note saved" });
  }

  timeoutError() {
    this.closeNotesModal();
    this.Notes.postNote({ type: 'error', description: "Time for edition exceeded" });
  }

  showOptions() {
    return this.notesProps.automation.join(', ');
  }

  onChangeClient() {
    this.changeClient = true;

    const processIdsForCurrentPG = this.workspace.processes
      .filter(process => process.processGroupId === this.processGroup.id)
      .map(process => process.id);
    const clientsIdsWithCurrentPG = this.workspace.processClientConfigurations
      .filter(conf => processIdsForCurrentPG.includes(conf.processId))
      .map(conf => conf.clientId);
    this.clientsOptions = JSON.parse(
        JSON.stringify(this.client.name === 'Internal' ? this.clients : this.clients.filter(client => clientsIdsWithCurrentPG.includes(client.id) || client.name === 'Internal'))
      ).sort((a, b) => a.name === 'Internal' ? -1 : b.name === 'Internal' ? 1 : a.name.localeCompare(b.name));

    this.clientToChange = this.clientsOptions.find(client => client.id === this.client.id);
  }

  onChangePG() {
    this.changePG = true;
    const processesIdsForCurrentClient = this.workspace.processClientConfigurations
      .filter(conf => conf.clientId === this.client.id)
      .map(conf => conf.processId);
    const processGroupsIdsForCurrentClient = this.workspace.processes
      .filter(process => processesIdsForCurrentClient.includes(process.id))
      .map(process => process.processGroupId);

    this.processGroups = JSON.parse(
      JSON.stringify(this.workspace.processGroups.filter(pg => processGroupsIdsForCurrentClient.includes(pg.id)))
    ).sort((a, b) => a.name.localeCompare(b.name));
    this.processGroupTochange = this.processGroups.find(processGroup => processGroup.id === this.processGroup.id);
  }

  changedClient() {
    const processesIds = this.workspace.processClientConfigurations
      .filter(processClientConfiguration => processClientConfiguration.clientId === this.clientToChange.id)
      .map(configuations => configuations.processId);
    const processGroupsIds = this.workspace.processes.filter(process => processesIds.includes(process.id)).map(process => process.processGroupId);
    this.processGroups = this.workspace.processGroups
      .filter(processGroup => processGroupsIds.includes(processGroup.id))
      .sort((a, b) => a.name.localeCompare(b.name));

    if (this.processGroupTochange && !this.processGroups.map(processGroup => processGroup.id).includes(this.processGroupTochange.id))
      this.processGroupTochange = null;
  }

  makeChanges() {
    const client = this.clientToChange || this.client;
    let processGroup;

    if (client.name !== 'Internal')
      processGroup = this.processGroupTochange || this.processGroup;
    else {
      const internalProcessesIds = this.workspace.processClientConfigurations
        .filter(conf => conf.clientId === client.id)
        .map(conf => conf.processId);
      const internalPGsIds = [...new Set(this.workspace.processes
        .filter(process => internalProcessesIds.includes(process.id))
        .map(process => process.processGroupId))];

      processGroup = internalPGsIds.length === 1 && this.workspace.processGroups.find(pg => pg.id === internalPGsIds[0]) || this.processGroupTochange || this.processGroup;
    }

    localStorage.setItem("roedl-time-started-client-id", client.id);
    localStorage.setItem("roedl-time-started-pg", processGroup.id);
    this.$location.path(`/clients/${client.id}/${this.slugify(client.name)}/work/${processGroup.id}/${this.slugify(processGroup.name)}`);
  }

  cancelChanges() {
    this.changeClient = false;
    this.clientToChange = null;

    this.changePG = false;
    this.processGroupTochange = null;
  }

  onInternalChange() {
    this.clientsOptions = JSON.parse(
        JSON.stringify(this.clients.filter(client => client.name !== 'Internal'))
      ).sort((a, b) => a.name === 'Internal' ? -1 : b.name === 'Internal' ? 1 : a.name.localeCompare(b.name));
    this.clientToChange = null;

    this.processGroups = null;
    this.processGroupTochange = null;

    this.changeClient = true;
    this.changePG = true;
  }

  exitTheProcess(note) {
    this.Notes.hide(note);
    localStorage.removeItem("roedl-time-started");
    localStorage.removeItem("roedl-time-started-interruption");
    localStorage.removeItem("roedl-worklog-id");
    localStorage.removeItem("roedl-interruption-id");
    this.StopWatch.stopAndclearCounter(this.counter);
    this.$location.path('/');
  }

  openClientNotePreviewModal() {
    this.notesModal = true;
    this.notesProps.text = this.clientNote;
    this.notesProps.preview = true;
  }

  showMainType(billingTypeId) {
    const reportingClient = this.selectedClient;
    return reportingClient.defaultBillingTypeId === billingTypeId ? ' (MAIN TYPE)' : '';
  }

  selectAnotherClient() {
    this.selectedClient = undefined;
    this.billingTypeId = this.client.defaultBillingTypeId;
    this.selectedKeywords = [];
    this.multiselectKeywords = this.client.multiselectKeywords && this.client.multiselectKeywords.map(keyword => ({id: keyword, name: keyword}));
  }

  formatNumberToTime(time) {
    const formattedHours = time.replaceAll(',', '.');
    const duration = moment.duration(formattedHours, 'hours');

    const timePart = (timePart) => {
      return timePart < 10 ? `0${timePart}` : timePart;
    };

    return `${timePart(duration.get('hours'))}:${timePart(duration.get('minutes'))}:${timePart(duration.get('seconds'))}`;
  }

  validateHour() {
    const hour = this.changeFinishTimeValue;

    if ((!hour || hour.length === 0) && this.changeFinishTimeValueFormatError) {
      delete this.changeFinishTimeValueFormatError;
      return;
    }

    clearTimeout(this.updateHoursFunction);
    this.updateHoursFunction = setTimeout(() => {
      if (!hour) {
        this.changeFinishTimeValueFormatError = true;
        return;
      }

      const numberFormat = /^(\d*([,.]\d*)|\d*)$/;
      const format = /^(\d+:[0-5]\d:[0-5]\d|\d*([,.]\d*)|\d*)$/;
      const match = hour.match(format);

      if (!match) {
        this.changeFinishTimeValueFormatError = true;
      }
      else {
        if (this.changeFinishTimeValueFormatError)
          delete this.changeFinishTimeValueFormatError;

        if (hour.match(numberFormat))
          this.changeFinishTimeValue = this.formatNumberToTime(hour);

        if (moment(hour, "HH:mm:ss").isBefore(moment(this.minChangeFinishTimeValue).startOf('second').add(1, 'second'), 'seconds'))
          this.changeFinishTimeValueMinError = true;
        else if (this.changeFinishTimeValueMinError)
          this.changeFinishTimeValueMinError = false;

        if (moment(hour, "HH:mm:ss").isAfter(moment(this.changeFinishTimeDefaultValueFormatted, "HH:mm:ss")))
          this.changeFinishTimeValueMaxError = true;
        else if (this.changeFinishTimeValueMaxError)
          this.changeFinishTimeValueMaxError = false;
      }
    }, 700);
  }

  changeFinishTimeHandler() {
    if (this.changeFinishTime) {
      if (!this.changeFinishTimeDefaultValue) {
        this.changeFinishTimeDefaultValue = moment().subtract(1, "minute").startOf('minute');
        this.changeFinishTimeDefaultValueFormatted = this.changeFinishTimeDefaultValue.format("HH:mm:ss");
      }
      
      this.changeFinishTimeValue = this.changeFinishTimeDefaultValueFormatted;
    }
    else {
      this.changeFinishTimeValue = null;
      this.changeFinishTimeValueFormatError = false;
      this.changeFinishTimeValueMinError = false;
      this.changeFinishTimeValueMaxError = false;
      this.changeFinishTimeDefaultValue = null;
    }
  }

  cancelNewProcess() {
    this.startNewProcessModal = false;
    this.selectedNewClient = null;
    this.selectedNewProcessGroup = null;
    this.checkInterruptsDuringProcess();
    const note = this.Notes.getNotes().find(note => note.type === 'changeFinishTimeError');
    if (note)
      this.Notes.hide(note);
  }

  changedNewClient() {
    const selectedNewClient = JSON.parse(this.selectedNewClient);
    const selectedNewProcessGroup = this.selectedNewProcessGroup ? JSON.parse(this.selectedNewProcessGroup) : {};

    const processesIds = this.workspace.processClientConfigurations
      .filter(processClientConfiguration => processClientConfiguration.clientId === selectedNewClient.id)
      .map(configuations => configuations.processId);
    const processGroupsIds = this.workspace.processes.filter(process => processesIds.includes(process.id)).map(process => process.processGroupId);
    this.newProcessPocessGroupsOptions = this.workspace.processGroups
      .filter(processGroup => processGroupsIds.includes(processGroup.id))
      .sort((a, b) => a.name.localeCompare(b.name));

    if (selectedNewProcessGroup.id && !this.newProcessPocessGroupsOptions.map(processGroup => processGroup.id).includes(selectedNewProcessGroup.id))
      selectedNewProcessGroup.id = null;
  }

  timeValueToHour(value) {
    return moment(value).startOf('second').add(1, 'second').format("HH:mm:ss");
  }

  startNewProcess() {
    const selectedNewClient = JSON.parse(this.selectedNewClient);
    const selectedNewProcessGroup = JSON.parse(this.selectedNewProcessGroup);
    localStorage.setItem("roedl-time-started-client-id", selectedNewClient.id);
    localStorage.setItem("roedl-time-started-pg", selectedNewProcessGroup.id);
    this.$location.path(`/clients/${selectedNewClient.id}/${this.slugify(selectedNewClient.name)}/work/${selectedNewProcessGroup.id}/${this.slugify(selectedNewProcessGroup.name)}`);

    this.selectedNewClient = null;
    this.selectedNewProcessGroup = null;
  }

  maximumOffsetTooltip() {
    return this.$translate.instant("WORK.MAXIMUM_PROCESS_OFFSET", {min: this.timeValueToHour(this.minChangeFinishTimeValue), max: this.changeFinishTimeDefaultValueFormatted});
  }

  changeFinishTimeDisabledTooltip() {
    if (!this.minChangeFinishTimeValue)
      return this.$translate.instant("WORK.LOADING_POSSIBLE_FINISH_TIME");
    else
      return this.$translate.instant("WORK.CHANGED_FINISH_TIME_DISABLED_TOOLTIP", { min: moment(this.minChangeFinishTimeValue).startOf('minutes').add(2, 'minutes').format("HH:mm:ss") });
  }

  async selectNewClientAndPG() {
    clearInterval(this.checkInterruptsDuringProcessInterval);
    this.currentTimeNotAvailableForNow = true;
    this.checkingIfChangeIsAvailable = true;
    await this.checkInterruptsDuringProcess(true);

    if (!this.currentTimeNotAvailableForNow) {
      this.newProcessClientOptions = JSON.parse(JSON.stringify(this.clients)).sort((a, b) => a.name === 'Internal' ? -1 : b.name === 'Internal' ? 1 : a.name.localeCompare(b.name));
      this.startNewProcessModal = true;
    } else
      this.checkInterruptsDuringProcess();
  }

  handlerChangeInvoicingToFalse(counterType) {
    this.StopWatch.startCounter(this[counterType]);
    this.changeInvoicingTimeValue = null;
    this.changeInvoicingTimeValueError = null;
  }

  changeWorklogInvoicingTimeHandler() {
    if (this.changeInvoicingTime) {
      this.StopWatch.stopCounter(this.counter);
      this.changeInvoicingTimeValue = this.formatCounterToTime(this.counter);
    }
    else {
      this.handlerChangeInvoicingToFalse('counter');
    }
  }

  changeInterruptsInvoicingTimeHandler() {
    if (this.changeInvoicingTime) {
      this.StopWatch.stopCounter(this.counterInt);
      this.changeInvoicingTimeValue = this.formatCounterToTime(this.counterInt);
    }
    else {
      this.handlerChangeInvoicingToFalse('counterInt');
    }
  }

  validateInvoicingTime() {
    const hour = this.changeInvoicingTimeValue;

    if ((!hour || hour.length === 0) && this.changeInvoicingTimeValueError) {
      delete this.changeInvoicingTimeValueError;
      return;
    }

    clearTimeout(this.updateHoursFunction);
    this.updateHoursFunction = setTimeout(() => {

      const numberFormat = /^(\d*([,.]\d*)|\d*)$/;
      const format = /^(\d+:[0-5]\d:[0-5]\d|\d*([,.]\d*)|\d*)$/;
      const match = hour.match(format);

      if (!match) {
        this.changeInvoicingTimeValueError = this.$translate.instant("INVALID_TIME_FORMAT");
      }
      else {
        if (this.changeInvoicingTimeValueError)
          delete this.changeInvoicingTimeValueError;

        if (hour.match(numberFormat))
          this.changeInvoicingTimeValue = this.formatNumberToTime(hour);
      }
    }, 700);
  }

  formatCounterToTime(counter) {
    return `${this.StopWatch.pad0(counter.hours)}:${this.StopWatch.pad0(counter.minutes)}:${this.StopWatch.pad0(counter.seconds)}`;
  }
}
